import { Info16Regular } from "@fluentui/react-icons";
import { PinnablePopover } from "../PinnablePopover/PinnablePopover";
import { useStyles } from "./MetricInfo.styles";
import type { IMetricInfoProps } from "./MetricInfo.types";

export const MetricInfo = ({ info, label }: IMetricInfoProps): JSX.Element => {
  const styles = useStyles();
  const helpLabel = `${label} metric help`;

  return (
    <PinnablePopover
      surfaceLabel={helpLabel}
      trigger={(triggerProps) => (
        <button
          type="button"
          className={styles.infoButton}
          aria-label={helpLabel}
          {...triggerProps}
        >
          <Info16Regular aria-hidden="true" />
        </button>
      )}
    >
      <div className={styles.blockGroup}>
        <div className={styles.block}>
          <div className={styles.captionLabel}>Measures</div>
          <p className={styles.captionText}>{info.measures}</p>
        </div>
        <div className={styles.block}>
          <div className={styles.captionLabel}>Calculated</div>
          <p className={styles.captionText}>{info.calculated}</p>
        </div>
        <div className={styles.block}>
          <div className={styles.captionLabel}>How To Read It</div>
          <p className={styles.captionText}>{info.howToRead}</p>
        </div>
      </div>
    </PinnablePopover>
  );
};
